import GravityBulkAdapter from 'district-ui-client/adapters/gravity-bulk'

export default class StudentAdapter extends GravityBulkAdapter {}
